import { useTranslation } from 'react-i18next'

import { UserActivityTable } from '@/components/admin/UserActivityTable'

/**
 * Cross-tenant user activity feed for platform admins.
 *
 * Same data shape as the per-tenant Combined tab on /admin/tenants/:id
 * but no tenant filter — surfaces every user action across every
 * provisioned shop. Where Mira spots churn / pattern outliers.
 *
 * The per-tenant Combined view is the place to chase a specific
 * cause-and-effect chain (Eric ↔ human); this cross-tenant feed is
 * the place to scan for "which tenants are even using the app this
 * week."
 */
export function AdminActivity() {
  const { t } = useTranslation('admin')

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          {t('user_activity.cross_tenant.title')}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('user_activity.cross_tenant.subtitle')}
        </p>
      </div>

      <UserActivityTable
        queryKeyPrefix="admin.user-activity.cross-tenant"
        defaultRange="7d"
      />
    </div>
  )
}
